import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"height":"var(--collection-banner-height)"}
}
const _hoisted_2 = { class: "relative h-full w-full" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")
  const _component_v_video = _resolveComponent("v-video")

  return ($options.mediaDesktop)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($options.mediaDesktop)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($options.mediaDesktop.type === 'image')
                  ? (_openBlock(), _createBlock(_component_v_image, {
                      key: 0,
                      source: $options.mediaDesktop.media,
                      "source-mobile": $options.mediaMobile?.media,
                      class: "h-full w-full object-cover object-center"
                    }, null, 8, ["source", "source-mobile"]))
                  : ($options.mediaDesktop.type === 'video')
                    ? (_openBlock(), _createBlock(_component_v_video, {
                        key: 1,
                        autoplay: "",
                        source: $options.mediaDesktop.media,
                        "source-mobile": $options.mediaMobile?.media,
                        class: "h-full w-full object-cover object-center"
                      }, null, 8, ["source", "source-mobile"]))
                    : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}